import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SplitButton } from 'primereact/splitbutton';
import Analytics from '../../utils/Analytics';
import { SegmentEventTypes } from '../../data/tracking';
import { WrappedButtonType } from './WrappedButtonType.enum';

export const WrappedSplitButton = props => {
	const menu = useRef(null);

	const [isMenuOpen, setIsMenuOpen] = useState(false);

	// props for this component
	const {
		className = '',
		dataqa = 'ui-split-button-common',
		buttonType = WrappedButtonType.Primary,
		onClick,
		menuClassName = '',
		...rest // rest of props for PrimeReact Button
	} = props;

	// top-level selector
	const spliButtonCls = classnames('common-ui-button split-button', {
		[className]: className,
	});

	const menuClassNames = classnames('common-ui-button split-button-menu', {
		[menuClassName]: menuClassName,
	});

	// assigning style classname
	const splitButtonCls = classnames({
		'ui-splitbutton-primary': buttonType === WrappedButtonType.Primary,
		'ui-splitbutton-secondary': buttonType === WrappedButtonType.Secondary,
		'ui-splitbutton-icon': buttonType === WrappedButtonType.Icon,
		'ui-splitbutton-tertiary-grey': buttonType === WrappedButtonType.TertiaryGrey,
		'ui-splitbutton-tertiary-white': buttonType === WrappedButtonType.TertiaryWhite,
		'ui-splitbutton-tertiary-ghost': buttonType === WrappedButtonType.TertiaryGhost,
	});

	// opens menu when primary button (left button) is clicked
	const clickHandler = () => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'splitbutton',
				field_name_dataqa: `${dataqa}-split-button`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (!onClick) {
			if (isMenuOpen) {
				menu.current.hide();
				setIsMenuOpen(false);
			} else {
				menu.current.show();
				setIsMenuOpen(true);
			}
		} else {
			onClick();
		}
	};

	return (
		<div className={spliButtonCls} data-qa={dataqa}>
			<SplitButton
				onClick={clickHandler}
				className={splitButtonCls}
				menuClassName={menuClassNames}
				ref={menu}
				dataqa={dataqa}
				{...rest}
			/>
		</div>
	);
};

WrappedSplitButton.propTypes = {
	// Text of the button.
	label: PropTypes.string,

	// Name of the icon.
	icon: PropTypes.string,

	// Items to define menu overlay
	model: PropTypes.array,

	// Click handler.
	onClick: PropTypes.func,

	/* Above props are specified by the documentation */

	// Additional ClassName of the component.
	className: PropTypes.string,

	// WrappedButtonType enum. Default to Primary.
	buttonType: PropTypes.oneOf([
		WrappedButtonType.Primary,
		WrappedButtonType.Secondary,
		WrappedButtonType.Icon,
		WrappedButtonType.TertiaryGrey,
		WrappedButtonType.TertiaryWhite,
		WrappedButtonType.TertiaryGhost,
	]),

	// For QA automation testing.
	dataqa: PropTypes.string,
};
